import {
  GET_LIST,
  sanitizeFetchType,
  type GetListParams,
  type QueryFunctionContext,
} from "react-admin";

import { CLIENT_SEARCH_SOURCE } from "@/constants/filters";
import { queryClient } from "@/constants/queryClient";

export const LIST_QUERY_KEY = sanitizeFetchType(GET_LIST);

type FilterRecord = Record<string, unknown> | undefined;
type QueryParamsShape = Partial<GetListParams & QueryFunctionContext>;

export const getFullListQueryData = <T>(
  resource: string,
  params?: GetListParams & QueryFunctionContext,
) => {
  const queryData = queryClient.getQueriesData<T>({
    queryKey: [resource, LIST_QUERY_KEY],
    exact: false,
  });

  const { pagination } = params ?? {};
  const typedFilter = (params?.filter as FilterRecord) ?? {};
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { [CLIENT_SEARCH_SOURCE]: _, ...serverFilters } = typedFilter;

  return queryData.find(([key]) => {
    const lastQueryKey = key[key.length - 1];
    const queryParams: QueryParamsShape =
      typeof lastQueryKey === "object" && lastQueryKey !== null
        ? lastQueryKey
        : {};

    const queryParamsFilter = (queryParams.filter as FilterRecord) ?? {};
    const {
      [CLIENT_SEARCH_SOURCE]: queryParamClientFilter,
      ...queryParamsServerFilters
    } = queryParamsFilter;

    const isPaginationEqual =
      queryParams.pagination?.page === pagination?.page &&
      queryParams.pagination?.perPage === pagination?.perPage;

    const noClientFilter = !queryParamClientFilter;
    const isServerFilterEqual =
      Object.keys(queryParamsServerFilters).length ===
        Object.keys(serverFilters).length &&
      Object.entries(serverFilters).every(
        ([key, value]) => queryParamsFilter[key] === value,
      );

    return isPaginationEqual && noClientFilter && isServerFilterEqual;
  })?.[1];
};
